import { render, staticRenderFns } from "./AppointmentInvitationsListableManager.vue?vue&type=template&id=228bf526&scoped=true&"
import script from "./AppointmentInvitationsListableManager.vue?vue&type=script&lang=js&"
export * from "./AppointmentInvitationsListableManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228bf526",
  null
  
)

export default component.exports